import { Component, EventEmitter, inject, LOCALE_ID, OnInit, Output } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  selectCtcValue,
  selectOtherComponents,
  selectSalaryData,
  selectStatutoryCompliances
} from '../../../../store/employee-salary/employee-salary.selectors'
import { combineLatest, filter, firstValueFrom, take, tap } from 'rxjs'
import {
  CTC,
  ExtendedSalaryComponent,
  StatutoryCompliances
} from '../../../../store/employee-salary/employee-salary.state'
import { CommonModule, NgIf, UpperCasePipe } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { User, UserRole } from '../../../../store/auth/auth.state'
import { selectSelectedUser } from '../../../../store/user/user.reducer'
import { selectEmployeeSalary } from '../../../../store/employee-salary/employee-salary.reducers'

@Component({
  selector: 'app-salary-summary',
  imports: [NgIf, FormsModule, ReactiveFormsModule, CommonModule, UpperCasePipe, CapitalizePipe],
  providers: [{ provide: LOCALE_ID, useValue: 'en-IN' }],
  templateUrl: './salary-summary.component.html',
  styleUrl: './salary-summary.component.scss'
})
export class SalarySummaryComponent implements OnInit {
  private store = inject(Store)
  @Output() screenNumber = new EventEmitter<number>()
  ctcValue!: number
  otherComponents!: ExtendedSalaryComponent[]
  compliancesList!: StatutoryCompliances
  salaryData!: [string, number][]
  user!: User
  ctc!: CTC
  async ngOnInit() {
    this.user = await firstValueFrom(
      this.store.pipe(
        select(selectSelectedUser),
        filter((user): user is User => !!user),
        take(1)
      )
    )
    combineLatest([
      this.store.select(selectStatutoryCompliances),
      this.store.select(selectCtcValue),
      this.store.select(selectOtherComponents),
      this.store.select(selectSalaryData)
    ])
      .pipe(
        take(1),
        tap(([compliancesList, ctcValue, otherComponents, salaryData]) => {
          this.compliancesList = compliancesList ?? {}
          this.ctcValue = ctcValue ?? 0
          this.otherComponents = otherComponents ?? []
          this.salaryData = (Object.entries(salaryData) ?? [])
            .filter(([key, value]) => {
              if (key === 'pf' && value === 0) return false
              // if (this.user.role === 'Contractor' && key === 'hra') return false
              if (this.isContractor(this.user) && key === 'hra') return false

              return true
            })
            .map(([key, value]) => {
              if (['pf', 'hra'].includes(key)) {
                key = key.toUpperCase()
              } else if (key === 'specialAllowance') {
                key = 'Special Allowance'
              }
              return [key, value]
            })
        })
      )
      .subscribe()
    console.log('salary data', this.salaryData)
    const salary = await firstValueFrom(this.store.select(selectEmployeeSalary))

    this.ctc = salary.ctc
  }

  //Helper method to check if the employee has any salary compliances
  hasValidCompliances() {
    return (
      this.compliancesList &&
      (Object.keys(this.compliancesList) as (keyof StatutoryCompliances)[]).some(
        key => key !== 'employerCapping' && this.compliancesList[key] === true
      )
    )
  }

  goToScreen() {
    this.screenNumber.emit(0) //Compliance Screen is 0
  }

  isContractor(employee: any): boolean {
    return employee?.userRoles?.some((r: UserRole) => r?.role?.name === 'Contractor') || false
  }
}
